interface timelineItem {
  year: number;
  items: Array<{ month: number | null; text: string }>;
}

export const timeline: Array<timelineItem> = [
 {
    year: 2022,
    items: [
      {
        month: 1,
        text: '在上海举办“御风飞翔·第六届体育产业嘉年华”',
      },
    ],
  },
   
  {
    year: 2021,
    items: [
      {
        month: 5,
        text: '在上海举办“年少有为·第一届SEAT体育教育产业峰会”',
      },
      {
        month: 1,
        text: '在上海举办“蓄势而起·第五届体育产业嘉年华”',
      },
    ],
  },
  {
    year: 2020,
    items: [
      {
        month: 7,
        text: '提出“新体育”概念，发现产业中的新机会，开启第二个五年',
      },
    ],
  },
  {
    year: 2019,
    items: [
      {
        month: 12,
        text: '在北京举办“翻山越岭·第四届体育产业嘉年华”',
      },
      {
        month: 8,
        text: '连续两年获得微博年度最具影响力体育MCN机构',
      },
      {
        month: 1,
        text: '在北京举办“和自己赛跑·第三届中国体育产业嘉年华”',
      },
    ],
  },
  {
    year: 2018,
    items: [
      {
        month: 10,
        text: '北京总部搬迁，并更新标识和口号（让体育产业高效连接）',
      },
    ],
  },
  {
    year: 2017,
    items: [
      {
        month: 12,
        text: '在北京举办“潮前走·第二届中国体育产业嘉年华”',
      },
      {
        month: 1,
        text: `腾讯战略入股懒熊体育
在上海举办“赶路的人·中国体育产业嘉年华”`,
      },
    ],
  },
  {
    year: 2016,
    items: [
      {
        month: 9,
        text: `联合华人文化和联科创盈成立元迅基金，规模1亿元
完成4200万A轮融资，华人文化继续领投，熠帆资本、娱乐工场和贵格基金跟投`,
      },
      {
        month: 5,
        text: `懒熊体育产业智库正式成立
“原力熊起·中国体育产业跨界峰会”在北京五棵松举办`,
      },
      {
        month: 3,
        text: `完成1200万元的Pre-A轮融资，华人文化领投，九合创投跟投`,
      },
    ],
  },
  {
    year: 2015,
    items: [
      {
        month: 7,
        text: '获得联科创盈200万元天使投资',
      },
      {
        month: 6,
        text: '开始公司化运营，同期设立上海办公室',
      },
    ],
  },
  {
    year: 2014,
    items: [
      {
        month: null,
        text: '懒熊体育公众号正式运营',
      },
    ],
  },
];
